import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props
});
export default SvgEmpty;
